import React from "react";
import { SVGIconProps } from "../type";

export default function Nem({ className, style }: SVGIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 874 872.6"
      className={className}
      style={style}
    >
      <g>
        <g>
          <g transform="translate(114 -188.972)">
            <path
              d="M323.2 1061.5l-5-2.5C123 944.6-24.7 756.1-84.7 530.8c-9.6-35.4-16.7-71.7-21.7-108.5-4.6-36.6-7.1-73.8-7.6-110.9 0-6.3-.8-5.4 5-8.4 73.4-41.7 151-72.2 233.2-91.3 30.5-7.1 60.9-12.5 91.8-16.3 42.5-5 85.1-7.1 128.1-6.3 24.2.4 48 2.1 71.7 4.6 119.7 12.9 232 48.8 337.1 107.6 1.7.8 2.9 1.7 4.6 2.5 1.7.8 2.5 2.1 2.5 4.2v6.3c-.4 21.7-1.3 43-2.9 64.7-2.5 30.9-6.7 61.3-12.5 91.8-12.5 65.5-32.1 128.5-59.2 189-43 96.4-101.8 182.3-176.1 257.4-53.4 54.2-113.1 101-179 139.7-2.5 1.7-4.6 2.9-7.1 4.6z"
              className="st0"
            ></path>
          </g>
          <g transform="translate(115.453 -187.596)">
            <path
              fill="#fff"
              d="M-75 330.9c53.4-30.9 109.3-55.1 168.1-72.6 80.1-23.8 161.4-35 244.9-33.4 38.8.8 103.4 7.1 114.3 11.3.4.8-.4 1.3-1.3 1.3-3.7 1.7-7.9 2.9-11.7 4.6-68.8 28.8-117.6 89.3-131.8 162.7-2.1 12.1-3.3 24.2-3.7 36.3-.4 18.4-2.1 36.7-7.5 54.6-18.4 64.7-71.3 115.1-136.8 130.2-86 19.5-172.8-23-210.3-102.7-2.1-4.6-3.7-9.2-4.6-13.8-6.3-27.1-10.8-54.2-14.2-81.8-3.7-30.4-5.8-60.9-5.8-91.3.4-2.1.4-3.3.4-5.4z"
              className="st1"
            ></path>
          </g>
          <g transform="translate(130.673 -186.319)">
            <path
              fill="#fff"
              d="M523.8 829.7c.8-7.9 1.7-15 2.1-22.5 2.1-41.3-6.7-80.5-26.3-116.8-18.8-34.6-45.1-62.2-78.8-83-2.9-2.1-6.3-3.7-9.2-5.8-46.3-29.2-74.7-70.5-84.7-124.3-17.9-96.8 43-190.2 138.5-213.2 33.8-7.9 66.7-7.1 99.7 3.3 27.1 8.4 53 19.6 78.8 31.7 17.9 8.4 35 17.5 52.2 27.1 2.1 1.3 3.7 2.1 6.3 3.7 0 1.7.4 2.9.4 4.6 0 22.1-1.3 44.6-2.9 66.7-2.9 32.5-7.9 65.1-14.6 96.8-20.5 94.3-56.7 181.5-109.3 262.4-14.6 22.5-30.4 44.2-47.1 65.1-1.7 1.3-2.6 2.9-5.1 4.2z"
              className="st2"
            ></path>
          </g>
          <g transform="translate(117.423 -173.453)">
            <path
              fill="#fff"
              d="M319.4 1003.5c-6.3-2.5-25.4-14.2-45.9-27.9-45.5-30.4-87.6-65.5-126-104.7-38.3-39.3-72.5-82.2-101.8-128.5-27.5-43-50.4-88-68.8-135.6-.4-1.3-.8-2.1-1.3-4.2 2.1 1.3 2.9 1.7 4.2 2.5 14.6 11.3 30 20.9 46.7 27.9 21.3 9.2 43.4 15.5 66.7 17.5 47.1 4.6 91.3-5 133.1-28.4 21.7-12.1 45.1-20 69.7-23.4 87.2-10.8 174 40.9 201.1 131 13.8 46.3 9.6 91.3-11.7 135.2-2.9 5.8-5.4 11.3-8.4 16.7-1.7 3.3-3.7 6.7-6.7 9.2-44.1 41.8-92.5 78.5-145 109.4-2.1 1.2-4.2 2.5-5.9 3.3z"
              className="st3"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
